import "./styles.scss";
import React, { useState, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { Testing } from "./Screens/Testing";
import MainLayout from "Components/layouts/main";
import { Login, Logout } from "Screens/auth";
import AuthLayout from "Components/layouts/auth";
import { Dashboard } from "Screens/home/Dashboard";
import { TransactionHome } from "Screens/history";
import TransferContainer, { TransferHome } from "Screens/transfer";
import Account from "Screens/account/AccountHome";
import AppErrorBoundary from "hoc/AppErrorBoundary";
import { OverlayLoader } from "Components/shared/loaders";
import { AuthProvider } from "providers/auth";
import ProtectedRoute from "containers/ProtectedRoute";
import { WalletHome } from "Screens/wallet";
import { DebitCardHome } from "Screens/debit-card";
import { BalanceProvider } from "providers/balance";


const ForgotPassword = lazy(() => import("./Screens/auth/ForgotPassword"));
const Register = lazy(() => import("./Screens/auth/Register"));
const RegisterComplete = lazy(() => import("./Screens/auth/RegisterComplete"));

const CurrencySwap = lazy(() => import("./Screens/history/CurrencySwap"));
const DebitCardTransactions = lazy(() =>
  import("./Screens/history/DebitCardTransactions")
);
const NairaWallet = lazy(() => import("./Screens/history/NairaWallet"));
const TransferTransactions = lazy(() =>
  import("./Screens/history/TransferTransactions")
);

const Beneficiary = lazy(() => import("./Screens/transfer/Beneficiary"));
const NewAccount = lazy(() => import("./Screens/transfer/NewAccount"));
const ViewBeneficiary = lazy(() => import("./Screens/transfer/ViewBeneficiary"));
const TransferHistory = lazy(() =>
  import("./Screens/transfer/TransferHistory")
);

const ProfileSettings = lazy(() => import("./Screens/account/ProfileSettings"));
const BVNSetting = lazy(() => import("./Screens/account/BVNSettings"));
const KYCSettings = lazy(() => import("./Screens/account/KYCSettings"));
const NOKinsSettings = lazy(() => import("./Screens/account/NOKinsSettings"));
const PasswordSettings = lazy(() =>
  import("./Screens/account/PasswordSettings")
);
const TransactionSettings = lazy(() =>
  import("./Screens/account/TransactionSetting")
);
const BankSettings = lazy(() => import("./Screens/account/BankSettings"));

const WalletCurrency = lazy(() => import("./Screens/wallet/WalletCurrency"));
const WalletDeposit = lazy(() => import("./Screens/wallet/WalletDeposit"));
const WalletWithdraw = lazy(() => import("./Screens/wallet/WalletWithdraw"));
const SwapCurrency = lazy(() => import("./Screens/wallet/SwapCurrency"));

// const DebitHome = lazy(() => import("./Screens/debit-card/DebitCardHome"));
const RequestDebitCard = lazy(() =>
  import("./Screens/debit-card/RequestDebitCard")
);
const FundCard = lazy(() => import("./Screens/debit-card/FundCard"));

function App() {
  return (
    <div className="scroller">
      <CombinedProviders>
        <AppErrorBoundary>
          <Suspense fallback={<OverlayLoader />}>
            <ScrollToTop />

            <Routes>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="wallet" element={<WalletHome />} />
                <Route
                  path="wallet/naira/deposit"
                  element={<WalletDeposit />}
                />
                <Route
                  path="wallet/naira/withdraw"
                  element={<WalletWithdraw />}
                />
                <Route path="wallet/swap-currency" element={<SwapCurrency />} />
                <Route path="wallet/:currency" element={<WalletCurrency />} />

                <Route path="debit-card" element={<DebitCardHome />} />
                <Route path="debit-card/fund-card" element={<FundCard />} />
                <Route
                  path="debit-card/request-debit-card"
                  element={<RequestDebitCard />}
                />

                <Route path="transfer" element={<TransferContainer />}>
                  <Route index element={<TransferHome />} />
                  <Route path="beneficiary" element={<Beneficiary />} />
                  <Route path="new-account" element={<NewAccount />} />
                  <Route
                    path="transfer-history"
                    element={<TransferHistory />}
                  />
                  <Route path="view-beneficiary" element={<ViewBeneficiary />} />
                </Route>
                <Route
                  path="transaction-history"
                  element={<TransactionHome />}
                />
                <Route
                  path="transaction-history/naira-wallet"
                  element={<NairaWallet />}
                />
                <Route
                  path="transaction-history/currency-swap"
                  element={<CurrencySwap />}
                />
                <Route
                  path="transaction-history/transfer-transactions"
                  element={<TransferTransactions />}
                />
                <Route
                  path="transaction-history/debit-card-transactions"
                  element={<DebitCardTransactions />}
                />

                <Route path="account" element={<Account />} />
                <Route
                  path="account/profile-setting"
                  element={<ProfileSettings />}
                />
                <Route path="account/bvn-setting" element={<BVNSetting />} />
                <Route path="account/update-kyc" element={<KYCSettings />} />
                <Route
                  path="account/next-of-kin"
                  element={<NOKinsSettings />}
                />
                <Route
                  path="account/password-setting"
                  element={<PasswordSettings />}
                />
                <Route
                  path="account/transaction-pin"
                  element={<TransactionSettings />}
                />
                <Route path="account/bank-setting" element={<BankSettings />} />
                {/* <Route path="account/bvn-setting" element={<BVNSetting />} /> */}

                <Route path="account" element={<Account />} />
                <Route path="logout" element={<Logout />} />
              </Route>
              <Route path="/auth" element={<AuthLayout />}>
                <Route index element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="sign-up" element={<Register />} />
                <Route
                  path="register-complete"
                  element={<RegisterComplete />}
                />
              </Route>

              <Route path="*" element={<Testing />} />
            </Routes>
          </Suspense>
        </AppErrorBoundary>
      </CombinedProviders>
    </div>
  );
}

const CombinedProviders = ({ children }) => {
  return (
    <AuthProvider>
      <BalanceProvider>
        <Router>{children}</Router>
      </BalanceProvider>
    </AuthProvider>
  );
};
export default App;
